// Translations
import accessKeyManagingDialog from '../components/access-key-managing-dialog/translations/ar'

// Translation: Model > Access key manager (Arabic)
export default Object.freeze({
	actions: {
		create: {
			hint: '',
			text: ''
		}
	},
	components: { accessKeyManagingDialog }
})
